export default __webpack_public_path__ + "static/media/jobcost_from.cd28e42e.png";